import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getStoreList } from "../../../Redux/Reducer/StoreListReducer";
import { ArrowLeftIcon, SearchIcon } from "@heroicons/react/solid";
import Cookies from "js-cookie";
import Login from "../UserAuth/Login/Login";
import { CheckCircleIcon, PencilAltIcon } from "@heroicons/react/outline";
import axiosInstance from "../../../Service/Interceptor";
import { toast, ToastContainer } from "react-toastify";
import { safeUseLayoutEffect } from "react-table";
import loader from "../../../assets/loader.gif";
import { getVendorAnalytics } from "../../../Redux/Reducer/VendorAnalyticsReducer";
import { getUsersAnalytics } from "../../../Redux/Reducer/UsersAnalyticsReducer";
import { getTopCustomers } from "../../../Redux/Reducer/TopCustomersReducer";

const AllTopCustomers = () => {
  let token = Cookies.get("access_token");
  const dispatch = useDispatch();
  const [loadMore, setLoadMore] = useState(1);
  const [effect, setEffect] = useState(0);

  useEffect(() => {
    dispatch(getTopCustomers("top_customer"));
  }, [loadMore]);

  

  const { topCustomers } = useSelector((state) => state.topCustomers);
  const topCustomersData = topCustomers?.data;

 
 
  return (
      <>
        {token ? (
          <>
            <section className="justify-center h-full w-full pt-2 pb-6 px-4 bg-white">
              <div className="col-span-12 flex justify-between items-center w-full  mb-5">
                <p className="text-xl font-semibold ">
                  All Top Customers 
                </p>
                <button
                className="flex justify-start items-center text-white text-sm bg-blue-600 font-medium  px-2 py-1 shadow-2xl cursor-pointer rounded-md"
               onClick={()=>window.history.back()}
              >
                <ArrowLeftIcon className="w-4 mx-1"/> Back
              </button>
              </div>

              <div className="grid grid-cols-12 gap-x-4 mb-5  ">
              
              <div className="col-span-12 space-y-4  text-center gap-x-8   rounded-md  p-4 h-auto w-full bg-white  text-gray-800 mb-2 drop-shadow-[0px_8px_10px_rgba(44,141,255,0.29)]">
                
              {topCustomersData?.data?.length !== 0 ? (
                  <div>
                    <table className="min-w-full divide-y divide-gray-50 shadow-md  border-collapse border border-gray-900">
                      <thead className="bg-[#ffe9af] text-xs font-bold text-black">
                        <tr>
                          <th
                            scope="col"
                            className="text-left border border-slate-300"
                          >
                            Customer Name
                          </th>
                          <th
                            scope="col"
                            className="text-center border border-slate-300"
                          >
                            Spent
                          </th>
                          <th
                            scope="col"
                            className="text-center border border-slate-300"
                          >
                            Total Order
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white">
                        {topCustomersData?.data?.map((item, index) => (
                          <tr key={index}>
                            <td className="whitespace-nowrap text-left text-xs font-normal text-black sm:pl-6 border border-slate-300">
                              {item.customer_name}
                            </td>
                            <td className="whitespace-nowrap text-center text-xs font-normal text-black  border border-slate-300">
                              <p className="truncate text-center ">
                                {item.total_spent}
                              </p>
                            </td>
                            <td className="whitespace-nowrap text-center text-xs font-semibold text-black sm:pl-6 border border-slate-300">
                              {item.total_orders}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                   
                  </div>
                ) : (
                  <div className="font-semibold text-md text-red-500 text-left">
                    No Top Customers!!
                  </div>
                )}
              </div>

           

                {/* <div className="col-span-12  flex  justify-end  items-end gap-x-8  rounded-md  w-full  mb-2">
                  {activeStoreData?.previous !== null && (
                    <button
                      type="submit"
                      class="group relative flex w-auto justify-center rounded-md border border-transparent bg-red-600 py-1 px-2 text-sm font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                      onClick={() => setLoadMore(loadMore - 1)}
                    >
                      Previous{" "}
                    </button>
                  )}

                  {activeStoreData?.next !== null && (
                    <button
                      type="submit"
                      class="group relative flex w-auto justify-center rounded-md border border-transparent bg-green-600 py-1 px-2 text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                      onClick={() => setLoadMore(loadMore + 1)}
                    >
                      next{" "}
                    </button>
                  )}
                </div> */}
              </div>
            </section>
          </>
        ) : (
          <Login />
        )}
      </>
   
  );
};

export default AllTopCustomers;
